export const aoi_covid_fields = ["el-pozon", "neiva"];
